/**
 * @module range
 * @desc   光标函数
 * @author: Liang Huang
 * @date: 2019-06-04
 */

/**
 * 判断是否支持range
 *
 * @export
 * @function
 * @returns boolean
 */
export function isSupportRange() {
  return typeof document.createRange === 'function' || typeof window.getSelection === 'function';
}
/**
 * 获取光标位置
 *
 * @export
 * @function
 * @returns range
 */

export function getCurrentRange() {
  var range = null;
  var selection = null;

  if (isSupportRange) {
    selection = document.getSelection();

    if (selection.getRangeAt && selection.rangeCount) {
      range = document.getSelection().getRangeAt(0);
    }
  } else {
    range = document.createRange();
  }

  return range;
}
/**
 * 插入内容
 *
 * @export
 * @function
 * @param {*} html
 * @param {*} atRange 上一次
 * @param {*} at 列表是否包含过滤 上一次
 */

export function insertHtmlAfterRange(html, atRange, hasFilter, addToRange) {
  if (atRange === void 0) {
    atRange = null;
  }

  if (hasFilter === void 0) {
    hasFilter = false;
  }

  if (addToRange === void 0) {
    addToRange = true;
  }

  var selection = null;
  var range = null;

  if (isSupportRange) {
    // IE > 9 and 其它浏览器
    selection = document.getSelection();

    if (selection.getRangeAt && selection.rangeCount) {
      var fragment = void 0,
          node = void 0,
          lastNode = void 0;
      range = selection.getRangeAt(0);

      if (atRange) {
        // 移除多余的@和@后面的字符
        range.setStart(atRange.startContainer, atRange.startOffset);

        try {
          range.setEnd(range.endContainer, hasFilter && range.endContainer.length > range.endOffset || range.endOffset === atRange.startOffset ? range.endOffset + 1 : range.endOffset);
        } catch (error) {}
      }

      range.deleteContents();
      var el = document.createElement('span');
      el.innerHTML = html; // 创建空文档对象,IE > 8支持documentFragment

      fragment = document.createDocumentFragment();

      while (node = el.firstChild) {
        lastNode = fragment.appendChild(node);
      }

      range.insertNode(fragment);

      if (addToRange) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      } else {
        range.collapse(true);
      }

      var lastChild = getLastChild(range.startContainer);

      if (addToRange && (!lastChild || lastChild.nodeName !== 'BR')) {
        range.commonAncestorContainer.appendChild(document.createElement('br'));
      }
    }
  } else if (document.getSelection() && document.getSelection().type !== 'Control') {
    // tslint-disable-line
    // IE < 9
    // @ts-ignore
    document.selection.createRange().pasteHTML(html); // tslint-disable-line
  }
}
/**
 * 光标结尾
 * @function
 * @param {*} el
 */

export function placeCaretAtEnd(el) {
  el.focus();

  if (typeof window.getSelection !== "undefined" && typeof document.createRange !== "undefined") {
    var range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range); // @ts-ignore
  } else if (typeof document.body.createTextRange !== "undefined") {
    // tslint-disable-line
    // @ts-ignore
    var textRange = document.body.createTextRange(); // tslint-disable-line

    textRange.moveToElementText(el);
    textRange.collapse(false);
    textRange.select();
  }
}
/**
 * 获取最后一个
 * @function
 * @param {*} elem
 */

export function getLastChild(elem) {
  var childNodes = elem.childNodes;

  if (childNodes.length < 1) {
    return null;
  }

  var node;

  for (var i = childNodes.length - 1; i >= 0; i--) {
    node = childNodes[i];

    if (node.nodeType === 3 && node.textContent === '') {
      continue;
    } else {
      return node;
    }
  }

  return null;
}